module.exports = __webpack_public_path__ + "b12b616c4a0368f8756f598b22e6c1dc.svg";